<!-- Start Navbar Area -->
<div class="navbar-area">
    <div class="evolta-nav">
        <div class="{{styleContainer}}">
            <nav class="navbar navbar-expand-md navbar-light">
                <a class="navbar-brand" routerLink="/">
                    <!-- <h3 style="color: white;">SolarCiti</h3> -->
                    <img src="assets/image/logo-1.png" alt="logo">
                </a>

                <button class="navbar-toggler" type="button" data-bs-toggle="collapse"
                    data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                    aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>

                <div class="collapse navbar-collapse mean-menu" id="navbarSupportedContent">
                    <ul class="navbar-nav">
                        <li class="nav-item dropdown">
                            <a routerLink="/" class="nav-link" routerLinkActive="active"
                                [routerLinkActiveOptions]="{exact: true}">
                                Home
                            </a>
                            <!-- <ul class="dropdown-menu">
                                <li class="nav-item" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                                    <a
                                        routerLink="/"
                                        class="nav-link"
                                        routerLinkActive="active"
                                        [routerLinkActiveOptions]="{exact: true}"
                                    >
                                        AI Startups
                                    </a>
                                </li>

                                <li class="nav-item" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                                    <a
                                        routerLink="/home-two"
                                        class="nav-link"
                                        routerLinkActive="active"
                                        [routerLinkActiveOptions]="{exact: true}"
                                    >
                                        Artificial Intelligence
                                    </a>
                                </li>

                                <li class="nav-item" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                                    <a
                                        routerLink="/home-three"
                                        class="nav-link"
                                        routerLinkActive="active"
                                        [routerLinkActiveOptions]="{exact: true}"
                                    >
                                        AI Solution
                                    </a>
                                </li>

                                <li class="nav-item" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                                    <a
                                        routerLink="/home-four"
                                        class="nav-link"
                                        routerLinkActive="active"
                                        [routerLinkActiveOptions]="{exact: true}"
                                    >
                                        Computer Vision
                                    </a>
                                </li>
                            </ul> -->
                        </li>

                        <li class="nav-item dropdown"  routerLinkActive="active" data-bs-toggle="collapse"
                            data-bs-target=".navbar-collapse.show">
                            <a routerLink="/about" class="nav-link">About Us</a>
                        </li>

                        <!-- <li class="nav-item dropdown">
                            <a href="javascript:void(0)" class="nav-link dropdown-toggle" data-bs-toggle="dropdown">
                                Pages <i class="fas fa-chevron-down"></i>
                            </a>
                            <ul class="dropdown-menu">
                                <li class="nav-item" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                                    <a routerLink="/about" class="nav-link" routerLinkActive="active">About Us</a>
                                </li>

                                <li class="nav-item" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                                    <a routerLink="/features" class="nav-link" routerLinkActive="active">Features</a>
                                </li>

                                <li class="nav-item" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                                    <a routerLink="/team" class="nav-link" routerLinkActive="active">Team</a>
                                </li>

                                <li class="nav-item" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                                    <a routerLink="/pricing" class="nav-link" routerLinkActive="active">Pricing</a>
                                </li>

                                <li class="nav-item" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                                    <a routerLink="/login" class="nav-link" routerLinkActive="active">Login</a>
                                </li>

                                <li class="nav-item" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                                    <a routerLink="/register" class="nav-link" routerLinkActive="active">Signup</a>
                                </li>

                                <li class="nav-item" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                                    <a routerLink="not-found" class="nav-link" routerLinkActive="active">404 Error</a>
                                </li>

                                <li class="nav-item" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                                    <a routerLink="/coming-soon" class="nav-link">Coming Soon</a>
                                </li>

                                <li class="nav-item" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                                    <a routerLink="/faq" class="nav-link" routerLinkActive="active">FAQ</a>
                                </li>
                            </ul>
                        </li> -->

                        <li class="nav-item dropdown">

                            <a href="javascript:void(0)" class="nav-link dropdown-toggle"
                                (click)="toggleDropdown('solar')">
                                Solar Solutions
                                <i class="fas fa-chevron-down"></i>
                            </a>

                            <ul class="dropdown-menu" [class.show]="activeDropdown === 'solar'">

                                <li class="nav-item">
                                    <a routerLink="/on-grid" class="nav-link" (click)="closeMobileMenu()">
                                        On-Grid Solar System
                                    </a>
                                </li>

                                <li class="nav-item">
                                    <a routerLink="/off-grid" class="nav-link" (click)="closeMobileMenu()">
                                        Off-Grid Solar System
                                    </a>
                                </li>

                                <li class="nav-item">
                                    <a routerLink="/hybrid" class="nav-link" (click)="closeMobileMenu()">
                                        Hybrid Solar System
                                    </a>
                                </li>

                            </ul>
                        </li>

                        <li class="nav-item dropdown">

                            <a href="javascript:void(0)" class="nav-link dropdown-toggle"
                                (click)="toggleDropdown('more')">
                                More
                                <i class="fas fa-chevron-down"></i>
                            </a>
                            <ul class="dropdown-menu" [class.show]="activeDropdown === 'more'">

                                <li class="nav-item">
                                    <a routerLink="/blog" class="nav-link" (click)="closeMobileMenu()">
                                        Blog
                                    </a>
                                </li>

                                <li class="nav-item">
                                    <a routerLink="/solar-subsidy" class="nav-link" (click)="closeMobileMenu()">
                                        Solar Subsidy
                                    </a>
                                </li>
                                 <li class="nav-item">
                                    <a routerLink="/refer-and-earn" class="nav-link" (click)="closeMobileMenu()">
                                       Refer and Earn
                                    </a>
                                </li>


                            </ul>
                        </li>

                        <!-- <li class="nav-item" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                            <a routerLink="/features" class="nav-link" routerLinkActive="active">Features</a>
                        </li> -->

                        <!-- <li class="nav-item" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                            <a routerLink="/blog" class="nav-link" routerLinkActive="active">Blog</a>
                        </li>

                        <li class="nav-item" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                            <a routerLink="/contact" class="nav-link" routerLinkActive="active">Contact</a>
                        </li> -->
                    </ul>

                    <div class="others-options" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                        <!-- <div class="option-item">
                            <i class="search-btn flaticon-search"></i>
                            <i class="close-btn fas fa-times"></i>

                            <div class="search-overlay search-popup">
                                <div class='search-box'>
                                    <form class="search-form">
                                        <input class="search-input" name="search" placeholder="Search" type="text">

                                        <button class="search-button" type="submit"><i class="fas fa-search"></i></button>
                                    </form>
                                </div>
                            </div>
                        </div> -->

                        <a routerLink="/contact" class="btn btn-primary">Contact Us</a>
                    </div>
                </div>
            </nav>
        </div>
    </div>
</div>
<!-- End Navbar Area -->